












































































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { BibliographyRealDetailReserve, ReserveSpecifyBranchCode } from '@/api'
import { systemParameterStore } from '@/utils/store-accessor'

@Component({
  components: {}
})
export default class CollectionReserveStatusDetail extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  item!: BibliographyRealDetailReserve

  get reserveUserId(): string {
    if (this.item.userId !== '') {
      return String(this.item.userId).padStart(
        systemParameterStore.userIdMaxDigits,
        '0'
      )
    }

    return ''
  }

  get rank(): number | string {
    return this.item.rank || ''
  }

  joinSpecifyBranchCodes(array: ReserveSpecifyBranchCode[]): string {
    return array.map(array => array.branchCode.shortName).join(' ')
  }
}
